import { useEffect, useState } from 'react';
import Container from 'components/Container';
import { ROUTES } from 'constants/index.js';
import { useAppContext } from 'services/context';
import { useTranslation } from 'services/hooks';
import './style.css';

const Footer = () => {
	const { Api } = useAppContext();
	const [links, setLinks] = useState(undefined);
	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'footer';

	useEffect(() => {
		(async () => {
			const _links = await Api.GetDynamicLinks(2, 2);
			if (_links) setLinks(_links);
			else {
				console.warn('no footer links falling to fallback');
				setLinks([
					{ linkDisplayName: getTranslation('header', 'header_home_link_title'), linkURL: ROUTES.HOME },
					{ linkDisplayName: getTranslation('header', 'header_about_link_title'), linkURL: ROUTES.ABOUT },
				]);
			}
		})();
	}, [getTranslation]);

	return (
		<div className="Footer">
			<Container className="Footer__content">
				<div className="top_section">
					<div className="logo"></div>
					<p className="paragraph"></p>
				</div>

				<div className="copyright">
					<p>{getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_text`)}</p>
					<div className="copyright__links">
						{links?.map(({ linkDisplayName, linkURL }) => (
							<a href={linkURL} target="_blank" rel="noreferrer" key={linkDisplayName}>
								{linkDisplayName}
							</a>
						))}
					</div>
				</div>
			</Container>
		</div>
	);
};

export default Footer;
